import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { StockProvider } from "@/contexts/StockContext";
import { LoadingQueueProvider } from "@/contexts/LoadingQueueContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StockProvider>
      <LoadingQueueProvider>
        <App />
      </LoadingQueueProvider>
    </StockProvider>
  </React.StrictMode>,
);
